/* src/app/module/shared/component/layout/bart/bart.component.scss */
app-bart {
  opacity: 0.08;
  position: fixed;
  left: 50%;
  bottom: -10px;
  pointer-events: none;
}
app-bart .bart * {
  position: absolute;
  box-sizing: content-box;
  -moz-box-sizing: content-box;
}
app-bart .bart {
  position: relative;
  width: 80px;
  height: 130px;
  margin: 0 auto;
}
app-bart .bart .head * {
  border: 1px solid #000;
}
app-bart .bart .head .no-border {
  border: none;
}
app-bart .bart .head .body {
  background: yellow;
}
app-bart .bart .head .hair {
  border-top: 1px solid #000;
  border-left: 1px solid #000;
  -webkit-border-radius: 2px 0 0 0;
  -moz-border-radius: 2px 0 0 0;
  border-radius: 2px 0 0 0;
}
app-bart .bart .head .hair1 {
  top: 22px;
  left: 0px;
  width: 6px;
  height: 7px;
  -webkit-transform: rotate(-22deg) skew(-7deg, 51deg);
  -ms-transform: rotate(-22deg) skew(-7deg, 51deg);
  transform: rotate(-22deg) skew(-7deg, 51deg);
}
app-bart .bart .head .hair2 {
  top: 20px;
  left: 5px;
  width: 9px;
  height: 7px;
  -webkit-transform: rotate(25deg) skew(23deg, 16deg);
  -ms-transform: rotate(25deg) skew(23deg, 16deg);
  transform: rotate(25deg) skew(23deg, 16deg);
}
app-bart .bart .head .hair3 {
  top: 17px;
  left: 12px;
  width: 9px;
  height: 8px;
  -webkit-transform: rotate(27deg) skew(22deg, 16deg);
  -ms-transform: rotate(27deg) skew(22deg, 16deg);
  transform: rotate(27deg) skew(22deg, 16deg);
}
app-bart .bart .head .hair4 {
  top: 15px;
  left: 20px;
  width: 10px;
  height: 9px;
  -webkit-transform: rotate(35deg) skew(22deg, 16deg);
  -ms-transform: rotate(35deg) skew(22deg, 16deg);
  transform: rotate(35deg) skew(22deg, 16deg);
}
app-bart .bart .head .hair5 {
  top: 13px;
  left: 29px;
  width: 9px;
  height: 9px;
  -webkit-transform: rotate(37deg) skew(22deg, 16deg);
  -ms-transform: rotate(37deg) skew(22deg, 16deg);
  transform: rotate(37deg) skew(22deg, 16deg);
}
app-bart .bart .head .hair6 {
  top: 12px;
  left: 37px;
  width: 10px;
  height: 9px;
  -webkit-transform: rotate(50deg) skew(24deg, 16deg);
  -ms-transform: rotate(50deg) skew(24deg, 16deg);
  transform: rotate(50deg) skew(24deg, 16deg);
}
app-bart .bart .head .hair7 {
  top: 12px;
  left: 45px;
  width: 10px;
  height: 8px;
  -webkit-transform: rotate(51deg) skew(24deg, 10deg);
  -ms-transform: rotate(51deg) skew(24deg, 10deg);
  transform: rotate(51deg) skew(24deg, 10deg);
}
app-bart .bart .head .hair8 {
  top: 14px;
  left: 54px;
  width: 9px;
  height: 7px;
  -webkit-transform: rotate(51deg) skew(24deg, 10deg);
  -ms-transform: rotate(51deg) skew(24deg, 10deg);
  transform: rotate(51deg) skew(24deg, 10deg);
}
app-bart .bart .head .hair9 {
  top: 15px;
  left: 61px;
  width: 9px;
  height: 7px;
  -webkit-transform: rotate(79deg) skew(35deg, 10deg);
  -ms-transform: rotate(79deg) skew(35deg, 10deg);
  transform: rotate(79deg) skew(35deg, 10deg);
}
app-bart .bart .head .head-left1 {
  top: 24px;
  left: 1px;
  width: 17px;
  height: 15px;
  border-left: 1px solid #000;
  -webkit-transform: rotate(-13deg);
  -ms-transform: rotate(-13deg);
  transform: rotate(-13deg);
}
app-bart .bart .head .head-left2 {
  top: 33px;
  left: 3px;
  width: 17px;
  height: 18px;
  border-left: 1px solid #000;
  -webkit-transform: rotate(-11deg);
  -ms-transform: rotate(-11deg);
  transform: rotate(-11deg);
}
app-bart .bart .head .head-left3 {
  top: 46px;
  left: 5px;
  width: 17px;
  height: 16px;
  border-left: 1px solid #000;
  -webkit-transform: rotate(-9deg);
  -ms-transform: rotate(-9deg);
  transform: rotate(-9deg);
}
app-bart .bart .head .head-left4 {
  top: 61px;
  left: 7px;
  width: 17px;
  height: 16px;
  border-left: 1px solid #000;
  -webkit-transform: rotate(-7deg);
  -ms-transform: rotate(-7deg);
  transform: rotate(-7deg);
}
app-bart .bart .head .head-left5 {
  top: 76px;
  left: 9px;
  width: 20px;
  height: 16px;
  border-left: 1px solid #000;
  -webkit-transform: rotate(-8deg);
  -ms-transform: rotate(-8deg);
  transform: rotate(-8deg);
}
app-bart .bart .head .head-left6 {
  top: 90px;
  left: 11px;
  width: 28px;
  height: 31px;
  border-left: 1px solid #000;
  -webkit-transform: rotate(2deg);
  -ms-transform: rotate(2deg);
  transform: rotate(2deg);
}
app-bart .bart .head .head-left7 {
  top: 119px;
  left: 10px;
  width: 27px;
  height: 8px;
  border-left: 1px solid #000;
  border-right: 1px solid #000;
  -webkit-transform: rotate(6deg);
  -ms-transform: rotate(6deg);
  transform: rotate(6deg);
}
app-bart .bart .head .head-right1 {
  top: 20px;
  left: 19px;
  width: 50px;
  height: 37px;
  border-right: 1px solid #000;
  -webkit-transform: rotate(-2deg);
  -ms-transform: rotate(-2deg);
  transform: rotate(-2deg);
}
app-bart .bart .head .head-right2 {
  top: 46px;
  left: 19px;
  width: 51px;
  height: 24px;
  -webkit-transform: rotate(-2deg);
  -ms-transform: rotate(-2deg);
  transform: rotate(-2deg);
}
app-bart .bart .head .head-right3 {
  top: 83px;
  left: 24px;
  width: 50px;
  height: 27px;
  border-right: 1px solid #000;
  -webkit-transform: rotate(-8deg);
  -ms-transform: rotate(-8deg);
  transform: rotate(-8deg);
}
app-bart .bart .head .ear {
  top: 88px;
  left: 5px;
  width: 11px;
  height: 13px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
app-bart .bart .head .ear .inner1 {
  top: 3px;
  left: 2px;
  width: 7px;
  height: 5px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  border-top: 1px solid #000;
  -webkit-transform: rotate(-21deg);
  -ms-transform: rotate(-21deg);
  transform: rotate(-21deg);
}
app-bart .bart .head .ear .inner2 {
  top: 3px;
  left: 4px;
  width: 7px;
  height: 5px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  border-top: 1px solid #000;
  -webkit-transform: rotate(-109deg);
  -ms-transform: rotate(-109deg);
  transform: rotate(-109deg);
}
app-bart .bart .head .ear .clip {
  top: 1px;
  left: 9px;
  width: 3px;
  height: 10px;
}
app-bart .bart .head .eyelid {
  top: 55px;
  left: 63px;
  width: 10px;
  height: 10px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
app-bart .bart .head .right-eye {
  top: 60px;
  left: 51px;
  width: 27px;
  height: 27px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  background: #fff;
  overflow: hidden;
}
app-bart .bart .head .right-eye .right-eye-pupil {
  top: 11px;
  left: 8px;
  width: 4px;
  height: 4px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  background: #000;
}
app-bart .bart .head .right-eye .eyelid-top {
  top: -18px;
  left: 0px;
  width: 30px;
  height: 17px;
  border-bottom: 1px solid #000;
  border-radius: 50% 50% 0 0;
  -webkit-animation-name: bartrighteyelidtop;
  -webkit-animation-duration: 10s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-delay: 2.5s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-play-state: running;
  animation-name: bartrighteyelidtop;
  animation-duration: 10s;
  animation-timing-function: linear;
  animation-delay: 2.5s;
  animation-iteration-count: infinite;
  animation-play-state: running;
}
app-bart .bart .head .right-eye .eyelid-bottom {
  bottom: -11px;
  left: 0px;
  width: 30px;
  height: 10px;
  border-top: 1px solid #000;
  border-radius: 0 0 50% 50%;
  -webkit-animation-name: bartrighteyelidbottom;
  -webkit-animation-duration: 10s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-delay: 2.5s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-play-state: running;
  animation-name: bartrighteyelidbottom;
  animation-duration: 10s;
  animation-timing-function: linear;
  animation-delay: 2.5s;
  animation-iteration-count: infinite;
  animation-play-state: running;
}
app-bart .bart .head .left-eye {
  top: 60px;
  left: 24px;
  width: 30px;
  height: 30px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  background: #fff;
  overflow: hidden;
}
app-bart .bart .head .left-eye .left-eye-pupil {
  top: 13px;
  left: 9px;
  width: 4px;
  height: 4px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  background: #000;
}
app-bart .bart .head .left-eye .eyelid-top {
  top: -21px;
  left: 0px;
  width: 30px;
  height: 20px;
  border-bottom: 1px solid #000;
  border-radius: 50% 50% 0 0;
  -webkit-animation-name: bartlefteyelidtop;
  -webkit-animation-duration: 10s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-delay: 2.5s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-play-state: running;
  animation-name: bartlefteyelidtop;
  animation-duration: 10s;
  animation-timing-function: linear;
  animation-delay: 2.5s;
  animation-iteration-count: infinite;
  animation-play-state: running;
}
app-bart .bart .head .left-eye .eyelid-bottom {
  bottom: -11px;
  left: 0px;
  width: 30px;
  height: 10px;
  border-top: 1px solid #000;
  border-radius: 0 0 50% 50%;
  -webkit-animation-name: bartlefteyelidbottom;
  -webkit-animation-duration: 10s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-delay: 2.5s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-play-state: running;
  animation-name: bartlefteyelidbottom;
  animation-duration: 10s;
  animation-timing-function: linear;
  animation-delay: 2.5s;
  animation-iteration-count: infinite;
  animation-play-state: running;
}
app-bart .bart .head .nose {
  top: 83px;
  left: 55px;
  width: 12px;
  height: 12px;
  border-top: 1px solid #000;
}
app-bart .bart .head .nose-tip {
  top: 82px;
  left: 60px;
  width: 14px;
  height: 12px;
  border-left: none;
  -moz-border-radius: 0 50% 50% 0%;
  -webkit-border-radius: 0 50% 50% 0;
  border-radius: 0 50% 50% 0;
  -webkit-transform: rotate(-6deg);
  -ms-transform: rotate(-6deg);
  transform: rotate(-6deg);
}
app-bart .bart .head .mouth {
  top: 101px;
  left: 27px;
  width: 50px;
  height: 15px;
  border-bottom: 1px solid #000;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
app-bart .bart .head .mouth-smile {
  top: 111px;
  left: 28px;
  width: 7px;
  height: 5px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  border-top: 1px solid #000;
  -webkit-transform: rotate(-52deg);
  -ms-transform: rotate(-52deg);
  transform: rotate(-52deg);
}
app-bart .bart .head .mouth-lip {
  top: 101px;
  left: 26px;
  width: 50px;
  height: 14px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
app-bart .bart .head .mouth-lip2 {
  top: 106px;
  left: 17px;
  width: 30px;
  height: 14px;
  -moz-border-radius: 32%;
  -webkit-border-radius: 32%;
  border-radius: 32%;
}
@-webkit-keyframes bartrighteyelidtop {
  0% {
    top: -18px;
  }
  2% {
    top: 0px;
  }
  4% {
    top: -18px;
  }
  100% {
    top: -18px;
  }
}
@keyframes bartrighteyelidtop {
  0% {
    top: -18px;
  }
  2% {
    top: 0px;
  }
  4% {
    top: -18px;
  }
  100% {
    top: -18px;
  }
}
@-webkit-keyframes bartrighteyelidbottom {
  0% {
    bottom: -11px;
  }
  2% {
    bottom: 0px;
  }
  4% {
    bottom: -11px;
  }
  100% {
    bottom: -11px;
  }
}
@keyframes bartrighteyelidbottom {
  0% {
    bottom: -11px;
  }
  2% {
    bottom: 0px;
  }
  4% {
    bottom: -11px;
  }
  100% {
    bottom: -11px;
  }
}
@-webkit-keyframes bartlefteyelidtop {
  0% {
    top: -21px;
  }
  2% {
    top: 0px;
  }
  4% {
    top: -21px;
  }
  100% {
    top: -21px;
  }
}
@keyframes bartlefteyelidtop {
  0% {
    top: -21px;
  }
  2% {
    top: 0px;
  }
  4% {
    top: -21px;
  }
  100% {
    top: -21px;
  }
}
@-webkit-keyframes bartlefteyelidbottom {
  0% {
    bottom: -11px;
  }
  2% {
    bottom: 0px;
  }
  4% {
    bottom: -11px;
  }
  100% {
    bottom: -11px;
  }
}
@keyframes bartlefteyelidbottom {
  0% {
    bottom: -11px;
  }
  2% {
    bottom: 0px;
  }
  4% {
    bottom: -11px;
  }
  100% {
    bottom: -11px;
  }
}
/*# sourceMappingURL=bart.component.css.map */
